<template>
  <FormAlert
    :error="formatRequestError"
    :field-errors="fieldErrors"
    :default-message="defaultText"
  />
</template>

<script lang="ts">
import FormAlert from "../../features/common/forms/FormAlert.vue"
import ScrollTo from "../UI/ScrollTo.vue"
import { FieldError } from "features/common/forms/FormAlert.vue"
import { PropType } from "vue"
import { defineComponent } from "vue"
import { AxiosError } from "axios"
import { FieldWithErrors } from "components/TopicForm/index.vue"
import { parseAxiosError } from "features/common/errors/parseAxiosError"

export type TopicFormError = AxiosError | boolean | string

export default defineComponent({
  name: "TopicFormAlert",
  components: { FormAlert, ScrollTo },
  props: {
    fieldsWithErrors: {
      type: Array as () => FieldWithErrors[],
      required: true,
    },
    defaultText: { type: String, required: true },
    requestError: {
      type: [Object, Boolean, Error] as PropType<
        TopicFormError | boolean | AxiosError
      >,
      required: false,
    },
  },
  computed: {
    fieldErrors(): FieldError[] {
      return this.fieldsWithErrors.map((field) => ({
        selector: field.selector,
        message: field.message,
      }))
    },
    formatRequestError(): string {
      if (!this.requestError) return null
      if (typeof this.requestError === "string") {
        return this.requestError
      }
      if (typeof this.requestError === "boolean") {
        if (this.requestError) {
          return "Es ist etwas schiefgelaufen. Bitte versuche es erneut."
        } else {
          return null
        }
      }
      const { request, response, message } = this
        .requestError as AxiosError<any>
      console.log("request", request)
      console.log("response", response)
      console.log("message", message)
      if (response) {
        return typeof response.data.message === "string"
          ? response.data.message
          : parseAxiosError(response)
      } else if (request) {
        return request
      } else {
        return message
      }
    },
  },
})
</script>
